/**
 * i18n setup.
 *
 * English only today. The point of wiring it now is cost: extracting strings
 * from eight components is an afternoon, and from a hundred and fifty it is a
 * mechanical week-long diff nobody can review. VentaWiz already spans US, EU
 * and Turkish marketplaces, so a second language is a question of when.
 *
 * Even with one language it pays for itself — plurals go through i18next's
 * rules rather than `count === 1 ? 'x' : 'xs'`, which is wrong in most
 * languages and in several English cases.
 */
import i18next from 'i18next'
import { initReactI18next } from 'react-i18next'

import { en } from './locales/en'

export const defaultNS = 'translation'
export const resources = { en: { translation: en } } as const

void i18next.use(initReactI18next).init({
  resources,
  lng: 'en',
  fallbackLng: 'en',
  defaultNS,
  interpolation: {
    // React already escapes anything it renders. Escaping again turns an
    // apostrophe in a tenant name into `&#39;` on screen.
    escapeValue: false,
  },
})

export default i18next
